import { fork, all } from 'redux-saga/effects';

import { checkAuth } from './auth/authSagas';
import { watchLogOut } from './auth/logoutSagas';
import { watchSignup } from './auth/signUpSagas';
import { watchSignIn } from './auth/loginSagas';
import { watchSendingResetPasswordLink } from './auth/sendResetPasswordLink';
import { watchPasswordChanges } from './auth/chagePasswordSagas';
import watchNotifications from './notifications';
import { watchUpdateAccount } from './auth/updateAccountSagas';
import {
  watchFetchDeviceReading,
  watchFetchWidgetDetails,
  watchSaveWidgetPlacement,
} from './widgetSagas';
import {
  watchFetchCollections,
  watchFetchCollectionBySlug,
  watchFetchDefaultCollection,
} from './collectionSagas';
import { watchFetchDevices, watchFetchDevice, watchUpdateDevice } from './deviceSagas';
import { watchFetchGroups } from './groupSagas';
import { watchFetchDeviceAnalytics } from './adminSagas';

export default function* rootSaga() {
  yield all([
    fork(watchSignup),
    fork(watchSignIn),
    fork(checkAuth),
    fork(watchLogOut),
    fork(watchNotifications),
    fork(watchSendingResetPasswordLink),
    fork(watchPasswordChanges),
    fork(watchUpdateAccount),
    fork(watchFetchWidgetDetails),
    fork(watchSaveWidgetPlacement),
    fork(watchFetchDeviceReading),
    fork(watchFetchCollections),
    fork(watchFetchCollectionBySlug),
    fork(watchFetchDefaultCollection),
    fork(watchFetchDevices),
    fork(watchFetchDevice),
    fork(watchFetchGroups),
    fork(watchUpdateDevice),
    fork(watchFetchDeviceAnalytics),
  ]);
}
